import React from "react";
import fulcrum from "../images/clients/image2.avif";
import dupreez from "../images/clients/dupreezcrest-edit-transformed-smaller.avif";
import threedom from "../images/clients/threedom-logo-text.avif";
import enlee from "../images/clients/enlee.avif";

const clientImage = {
  // height: "22rem",
  // width: "auto",
  // mixBlendMode: "colorBurn",
};

const Clients = () => {
  return (
    <div id="clients" className="mt-8">
      <section data-aos="fade-up">
        <div className="my-4 py-4">
          <h2 className="my-2 text-center text-3xl text-bridgeway uppercase font-bold">
            Some of Our Clients
          </h2>
          <div className="flex justify-center">
            <div className="w-24 border-b-4 border-bridgeway"></div>
          </div>
        </div>

        <div className="p-8">
          <div className="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
            <div
              style={clientImage}
              className="overflow-hidden flex flex-col justify-center items-center transition-all ease-in-out opacity-100"
              data-aos="zoom-in"
              data-aos-delay="600"
            >
              <img src={enlee} alt="client" className="h-2/4 border" />
              <p className="font-bold text-center text-bridgeway">
                Enlee Stevedoring
              </p>
              <p className="w-1/2 text-center text-neutral-300">
                A bespoke project management platform where they can track
                labour spent on vessels and related statistics.
              </p>
            </div>
            <div
              style={clientImage}
              className="overflow-hidden flex flex-col justify-center items-center transition-all ease-in-out opacity-100"
              data-aos="zoom-in"
              data-aos-delay="600"
            >
              <img
                src={fulcrum}
                alt="client"
                className="h-2/4 filter drop-shadow-custom"
              />
              <p className="font-bold text-center text-bridgeway">
                Fulcrum Analytics (Pty) Ltd
              </p>
              <p className="w-1/2 text-center text-neutral-300">
                A business website and the I-Spy intelligence platform for
                capturing and distributing intelligence on criminal events.
              </p>
            </div>
            <div
              style={clientImage}
              className="overflow-hidden flex flex-col justify-center items-center transition-all ease-in-out opacity-100"
              data-aos="zoom-in"
              data-aos-delay="600"
            >
              <img
                src={threedom}
                alt="client"
                className="h-2/4 filter drop-shadow-custom"
              />
              <p className="font-bold text-center text-bridgeway">
                Threedom Consulting & Sales
              </p>
              <p className="w-1/2 text-center text-neutral-300">
                For Threedom Consulting & Sales we created a business website
                and bespoke eCommerce platform.
              </p>
            </div>
            <div
              style={clientImage}
              className="overflow-hidden flex flex-col justify-center items-center transition-all ease-in-out opacity-100"
              data-aos="zoom-in"
              data-aos-delay="600"
            >
              <img
                src={dupreez}
                alt="client"
                className="h-2/4 filter drop-shadow-custom"
              />
              <p className="text-bridgeway font-semibold text-center">
                The History of the Du Preez Family in South Africa
              </p>
              <p className="w-1/2 text-center text-neutral-300">
                For the History of the Du Preez Family in South Africa we
                created a bespoke genealogy website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;
